export default __webpack_public_path__ + "static/media/JobHunter.4937db3d.png";